<template>
  <section class="my-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="here px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">商品のご注文</h3>
    <!-- スターターパッケージ ここから -->
    <p class="exp exp0">
      ご希望の商品の数量を選択後、「カートに入れる」を押してください。<br />
      ツール品を除く商品の累計15,750円以上ご購入いただくと、その後は更にお得な会員価格でご購入いただけます。<br />
      本ページの商品（ツール品除く）は、標準の会員価格を表示しております。決済金額は、最終確認ページでご確認ください。<br />
      <router-link to="/shopping/qa">送料、ポイントについて</router-link>
    </p>
    <div v-show="!selectStart">
      <div class="lineup_title mt-50">
        <h2 class="mb-0">スターターセット</h2>
      </div>
      <p class="exp exp1 exp2">
        スターターセットをご購入いただくと、お好みの1商品をプレゼントさせていただきます。
      </p>
      <div class="list-shouhin">
        <ul>
          <orderItem
            v-for="item in start"
            :key="item.no"
            :type="'start'"
            :item="item"
            :no="item.no"
          :price="item.price"
          :showPrice="false"
          :point="item.point"
          :showPoint="false"
          :start="true"
            @myClick="selectStart = true"
          ></orderItem>
        </ul>
      </div>
    </div>
    <div v-show="selectStart" class="lineup_title">
      <h2 class="mb-0">プレゼント品</h2>
      <div id="divAnyOne" class="list-shouhin">
        <ul>
          <orderItem
            v-for="item in anyone"
            :key="item.no"
            :type="'anyone'"
            :item="item"
            :no="item.no"
            :showPrice="false"
            :showPoint="false"
          :start="false"
          ></orderItem>
        </ul>
      </div>
      <!-- スターターパッケージ ここまで -->
    </div>
    <!-- 通常の商品 -->
    <div class="lineup_title mt-50">
      <h2 class="mb-0">商品</h2>
    </div>
    <p class="exp exp1 exp2">
      ご希望の商品の数量を選択後、「カートに入れる」を押してください。
      <br />最後に「カートへ進む」を押してください。
    </p>
    <div class="list-shouhin">
      <ul>
        <orderItem
          v-for="item in goods"
          :key="item.no"
          :type="'goods'"
          :item="item"
          :no="item.no"
          :price="item.price"
          :showPrice="true"
          :point="item.point"
          :showPoint="true"
          :start="false"
        ></orderItem>
      </ul>
    </div>
    <!-- ツール品 -->
    <div class="lineup_title mt-50">
      <h2 class="mb-0">ツール品</h2>
    </div>
    <div class="list-shouhin">
      <ul>
        <orderItem
          v-for="item in tools"
          :key="item.no"
          :type="'tools'"
          :item="item"
          :no="item.no"
          :price="item.price"
          :showPrice="true"
          :point="item.point"
          :showPoint="true"
          :start="false"
        ></orderItem>
      </ul>
    </div>
    <div class="box-p-20 text-center mt-5 admission_go_cart">
      <button
        id="btnNextCart"
        v-on:click="putData"
        type="button"
        class="confirm-01 clear"
      >
        カートへ進む
      </button>
    </div>
  </section>

  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>


<script>
import orderItem from "./components/OrderItem";
import Request from "@/modules/Request";
let request = new Request();
import Products from "@/modules/Products";
let productStore = new Products();
export default {
  components: {
    orderItem,
  },
  data() {
    return {
      goods: [],
      tools: [],
      start: [],
      anyone: [],
      selectStart: false,
    };
  },
  mounted() {
    productStore.loadProducts();
    this.getData();
    window.scroll(0, 0);
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getProducts",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.goods = data.goods;
          this.tools = data.tools;
          this.start = data.start;
          this.anyone = data.anyone;
        });
    },
    putData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "canNextStep",
        [0, true],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push({
            path: "/shopping/order/confirm",
          });
        });
    },
  },
};
</script>

<style scoped>
.lineup_title {
  padding: 5px 0;
}
.lineup_title:nth-child(n + 4) {
  border-top: 1px solid #eee;
}
.lineup_title h2 {
  margin: 0;
}
.list-shouhin {
  margin-bottom: 80px;
}
.list-shouhin > ul {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}
.lineup_title.mt-50 {
  margin-top: 50px;
}
.lineup_title:nth-of-type(4) {
  border-bottom: 1px solid #eee;
}
.list-starter {
  width: 100%;
}
.admission_go_cart {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  border-top: 1px solid;
}
</style>